import Config from "../config";
import { SavedSearch } from "../types/SavedSearchTypes";
import { ITagQuery } from "../types/TagQueryTypes";
import { DefaultResponse } from "../types/UtilTypes";
import { localStorageGetItem } from "../utils/LocalStorage";

export interface CreateSearchResponse {
  id: string;
  message: string;
}
export interface CreateSearchRequest {
  name: string;
  search: ITagQuery;
  footerId: string;
  publicArchive: boolean;
}

export interface GetSearchResponse {
  _id: string;
  userUid: string;
  name: string;
  search: ITagQuery;
  footerId: string;
  publicArchive: boolean;
  labels: string[];
}

export const createNewSearch = async (
  createSearch: CreateSearchRequest
): Promise<string> => {
  const userUid = localStorageGetItem("USER_UID");
  const token = localStorageGetItem("USER_TOKEN");
  const response = await fetch(`${Config.SERVER_URL}/search`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify({ ...createSearch, userUid }),
  });
  const content: DefaultResponse<CreateSearchResponse> = await response.json();

  if (content.status === "ok") {
    return (content.data as CreateSearchResponse).id;
  }
  throw new Error(content.code);
};

export const getAllUserSavedSearches = async (): Promise<SavedSearch[]> => {
  const userUid = localStorageGetItem("USER_UID");
  const token = localStorageGetItem("USER_TOKEN");
  const response = await fetch(`${Config.SERVER_URL}/search/user/${userUid}`, {
    method: "GET",
    headers: {
      Authorization: "Bearer " + token,
    },
  });
  const content: DefaultResponse<GetSearchResponse[]> = await response.json();
  if (content.status === "ok") {
    return (content.data as GetSearchResponse[]).map((savedSearch) => {
      return {
        id: savedSearch._id,
        userUid: savedSearch.userUid,
        name: savedSearch.name,
        search: savedSearch.search,
        footerId: savedSearch.footerId,
        publicArchive: savedSearch?.publicArchive || false,
        labels: savedSearch.labels || [],
      };
    });
  }
  throw new Error();
};

export const updateSavedSearch = async (
  searchId: string,
  body: {
    name: string;
    publicArchive: boolean;
    footerId?: string;
    search?: ITagQuery;
    labels?: string[];
  }
): Promise<boolean> => {
  const token = localStorageGetItem("USER_TOKEN");
  const userUid = localStorageGetItem("USER_UID");
  const response = await fetch(`${Config.SERVER_URL}/search/${searchId}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    method: "PUT",
    body: JSON.stringify({ ...body, userUid }),
  });

  if (`${response.status}`[0] === "2") {
    return true;
  }

  return false;
};

export const deleteSavedSearch = async (searchId: string): Promise<boolean> => {
  const token = localStorageGetItem("USER_TOKEN");
  const response = await fetch(`${Config.SERVER_URL}/search/${searchId}`, {
    method: "DELETE",
    headers: {
      Authorization: "Bearer " + token,
    },
  });

  if (`${response.status}`[0] === "2") {
    return true;
  }

  return false;
};

export const updateOrderSavedSearch = async (body: {
  newOrder: string[];
}): Promise<boolean> => {
  const token = localStorageGetItem("USER_TOKEN");
  const response = await fetch(`${Config.SERVER_URL}/search/updateOrder`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    method: "PUT",
    body: JSON.stringify(body),
  });

  if (`${response.status}`[0] === "2") {
    return true;
  }

  return false;
};
